<lex-base-dialog>
	<div base-dialog-title>Set Maximum Service Scaling Count</div>
	<div base-dialog-body class="fontify-13px" style="overflow: auto; max-height: 350px; padding: 8px;">
		<div style="display: flex; flex-direction: column; gap: 16px; align-items: center;">
			<lex-text-input class="note-body-input" [type]="'input'" placeholder="Please add a note."	[(ngModel)]="maxCount" rows=10></lex-text-input>
		</div>
	</div>
	<div base-dialog-actions>
		<div style="display:flex; flex-direction: row; justify-content: flex-end; padding: 12px; gap: 4px;">
			<lex-flat-button (click)="ok()" [type]="'action'" label="Ok" class="center-button-text"></lex-flat-button>
			<lex-flat-button [type]="'action'" label="Cancel" matDialogClose></lex-flat-button>
		</div>
	</div>
</lex-base-dialog>
